import PropTypes from 'prop-types';

import classNames from 'classnames';

const propTypes = {
	/**
	 * Clases adicionales.
	 */
	className: PropTypes.string,
};

const FormCol = ({ children, className, ...r }) => {
	const classes = classNames('form-col', className);

	return (
		<div className={classes} {...r}>
			{children}
		</div>
	);
};

FormCol.propTypes = propTypes;

export default FormCol;
